<h1 class="table__title">System Alerts</h1>
<div class="table__control">

</div>
<ng-template #noDocs>
  <h2>No System Alerts</h2>
</ng-template>
<div class="table__container">
  <h4>Review Deadline Date: {{reviewDeadlineDate | aspenDate}}</h4>
  <table *ngIf="alerts?.length > 0;else noDocs" class="table__inner" mat-table [dataSource]="dataSource">


    <ng-container matColumnDef="AlertTemplateName">
      <th mat-header-cell *matHeaderCellDef>Alert Category</th>
      <td mat-cell *matCellDef="let element">
        {{ element?.propertiesObj.AlertTemplatename | asyncChoiceList:objectStore:'AlertTemplates' | async }}</td>
    </ng-container>

    <ng-container matColumnDef="AlertDueDate">
      <th mat-header-cell *matHeaderCellDef>Alert Date</th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.AlertDueDate | aspenDate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="AlertCancelled">
      <th mat-header-cell *matHeaderCellDef>Alert Cancelled</th>
      <td mat-cell *matCellDef="let element"><img
          [src]="element?.propertiesObj.AlertCancelled ? 'assets/images/icon-cross.svg' : ''" /> </td>
    </ng-container>

    <ng-container matColumnDef="AlertSendDate">
      <th mat-header-cell *matHeaderCellDef>Date Sent</th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.AlertSendDate | aspenDate }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<div class="table__pagination">
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
